// The backdrop interface (HANDOVER Section 8). Everything in front of it
// (calibration, perches, insect, picker, grounding) must work with any
// implementation. CameraBackdrop is the live feed; VirtualBackdrop is the
// rendered environment, not built yet.
export class Backdrop {
  /** Human-readable kind, e.g. 'camera' | 'virtual'. */
  get kind() {
    return 'none';
  }

  /** True once the backdrop can draw something meaningful. */
  get ready() {
    return false;
  }

  /** Whether calibration (camera pose) means anything for this backdrop. */
  get needsCalibration() {
    return false;
  }

  /** Acquire resources. May need to run inside a user gesture. */
  async start() {
    return true;
  }

  stop() {}

  resize(_width, _height) {}

  update(_now) {}

  /** Draw the backdrop into the renderer. Called before the main scene. */
  render(_renderer) {}

  /** Anything the debug overlay should show. */
  getInfo() {
    return {};
  }
}
